import { render, staticRenderFns } from "./Training-ls.vue?vue&type=template&id=125f0078&scoped=true&"
import script from "./Training-ls.vue?vue&type=script&lang=js&"
export * from "./Training-ls.vue?vue&type=script&lang=js&"
import style0 from "./Training-ls.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Training-ls.vue?vue&type=style&index=1&id=125f0078&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125f0078",
  null
  
)

export default component.exports